import { Box, Tab, Tabs, styled } from "@mui/material";

export const TabsRoot = styled(Box)(() => ({
  minWidth: 0,
  overflow: "hidden",
  width: "100%"
}));

export const TabsContainer = styled(Tabs)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  maxWidth: "100%",
  width: "100%",
  fontFamily: "Inter",
  fontWeight: "500",
  "> .Mui-disabled": {
    display: "none"
  },
  ".MuiTab-textColorPrimary:not([data-selected='true'])": {
    color: theme.customColors.systemPrimary01
  },
  ".MuiTab-textColorPrimary[data-selected='true']": {
    color: theme.customColors.accentVariantA
  },
  ".MuiTabs-indicator": {
    background: theme.customColors.accentVariantA,
    borderRadius: "1.5rem"
  }
}));

export const TopicTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontSize: "0.875rem",
  letterSpacing: "0.0313em",
  fontWeight: 600,
  height: "1.5rem",
  minWidth: "3rem",
  margin: "0 0.35rem",
  lineHeight: "1.5rem",
  borderBottom: `2px solid ${theme.customColors.border}`,
  color: theme.customColors.systemPrimary01,
  "&[data-selected='true']": {
    borderBottom: `2px solid ${theme.customColors.accentVariantA}`,
    color: theme.customColors.accentVariantA
  },
  "&.Mui-focusVisible": {
    border: `1px solid ${theme.customColors.accentVariantA}`
  }
}));
